import axios from 'axios';
import {
  fetchProductsRequest,
  fetchProductsSuccess,
  fetchProductsFailure,
  updateProductRequest,
  updateProductSuccess,
  updateProductFailure,
  fetchProductsVariantsRequest,
  fetchProductsVariantsSuccess,
  fetchProductsVariantsFailure
} from '../Reducer/productReducer';

export const fetchProducts = (filters = {}, page = 1, itemsPerPage = 10) => async (dispatch) => {
  dispatch(fetchProductsRequest());
  try {
    const response = await axios.get('/api/get_product_list', {
      params: {
        ...filters,
        page,
        limit: itemsPerPage,
      },
      withCredentials: true,
    });

    // Assuming your API response looks something like this:
    // {
    //   products: [/* array of products */],
    //   meta: {
    //     totalRecords: 670,
    //     totalPages: 34,
    //     currentPage: 1,
    //     pageSize: 20
    //   }
    // }
    
    const { products, meta } = response.data; // Extract products and meta information
console.log("product list",response.data)
    dispatch(fetchProductsSuccess({ products, meta }));
  } catch (err) {
    console.error('Fetch products error:', err);
    console.log("fetch product error",err)
  
    dispatch(fetchProductsFailure('Your session is expired please login '));
  }
};





export const updateProduct = (product) => async (dispatch) => {
    console.log("from action",product)
  dispatch(updateProductRequest());
  try {
    const response = await axios.post(`/api/update_product/`, product, {
      withCredentials: true,
    });
    dispatch(updateProductSuccess(response.data.product));
    return response.data.product; // Return the updated product for further use in `handleSubmit`
  } catch (err) {
    console.error('Update product error:', err);
    dispatch(updateProductFailure('Failed to update product.'));
  }
};
export const updateWoocommerceProduct = (product) => async (dispatch) => {
  console.log("from action",product)
dispatch(updateProductRequest());
try {
  const response = await axios.post(`/api/update_woocommerce_product/`, product, {
    withCredentials: true,
  });
  dispatch(updateProductSuccess(response.data.product));
  return response.data.product; // Return the updated product for further use in `handleSubmit`
} catch (err) {
  console.error('Update product error:', err);
  dispatch(updateProductFailure('Failed to update product.'));
}
};

//fetch products variations
export const fetchProductVariants = (product_id) => async (dispatch) => {
  dispatch(fetchProductsVariantsRequest());

  try {
      // Make the API call to get product variants
      const response = await axios.post(
          '/api/get_product_variants',
          { product_id },
          { withCredentials: true }
      );

      const products = response.data;

      // Dispatch success action with product data
      dispatch(fetchProductsVariantsSuccess(products));
  } catch (err) {
      console.error('Error fetching product variants:', err.message || err);

      // Dispatch failure action with an error message
      dispatch(fetchProductsVariantsFailure('Failed to fetch product variants'));
  }
};

